<template>
  <div>
    <v-layout v-if="user && user.tickets && user.tickets.length > 0" row wrap class="ma-0">
      <v-flex xs7>
        <div class="caption pt-2 pl-2" style="word-break: break-all">
          <div><v-icon small class="mr-1">person</v-icon>{{ user.tickets[0][1] }}</div>
        </div>
      </v-flex>
      <v-flex xs5 class="text-xs-right">
        <!-- Ticket Status -->
        <div>
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-chip
                small
                :color="ticketColorStatus(user.tickets[0][2])"
                dark
                class="caption"
                alt="Ticket Status"
                @click.stop="showEditTicketStatus"
                v-on="on"
              >
                {{ ticketLabelStatus(user.tickets[0][2]) | capitalize }}
                <v-icon small class="ml-1"> arrow_drop_down</v-icon>
              </v-chip>
            </template>
            <span>Ticket Status</span>
          </v-tooltip>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="showManageTicketStatus"
      content-class="nooverflow"
      class="dialog-nooverflow"
      width="400px"
      persistent
      style="overflow-y: none !important"
    >
      <v-card class="pa-3">
        <div class="mb-3" style="font-size: 21px; font-weight: 600">Change status</div>
        <div>
          <v-select
            v-model="input.ticketStatus"
            v-validate="'required'"
            :items="
              $store.getters.ticketStatusOptions.map((item) => ({
                label: toCapitalCase(item.label),
                value: item.value
              }))
            "
            name="ticketStatus"
            label="Status"
            single-line
            item-text="label"
            item-value="value"
            :return-object="false"
            dense
            :hide-details="!errors.has('ticketStatus')"
            :error="errors.has('ticketStatus')"
            :error-messages="errors.first('ticketStatus')"
            placeholder="Select status"
            outline
          ></v-select>
        </div>
        <div class="text-xs-center mt-2">
          <v-btn
            :loading="loading"
            outline
            color="grey"
            @click.stop="showManageTicketStatus = false"
            >Cancel</v-btn
          >
          <v-btn :loading="loading" depressed color="primary" @click.stop="onSave"> Save </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import ticketMixin from '@/mixins/ticketMixin'
import { handleApiError } from '@/api/util'
import ticket3TicketManagementApi from '@/api/ticket3/ticket-management'
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [ticketMixin],
  props: ['user'],
  data() {
    return {
      input: {
        ticketStatus: ''
      },
      showManageTicketStatus: false,
      loading: false
    }
  },
  methods: {
    showEditTicketStatus() {
      this.input.ticketStatus = this.user.tickets[0][2]
      this.showManageTicketStatus = true
    },
    async onSave() {
      const vm = this
      const ticketId = vm.user.tickets[0][0]

      vm.loading = true
      if (vm.$store.state.livechat.bot.unlock_ticket_3) {
        const data = {
          id: ticketId,
          page_id: vm.$store.state.livechat.pageid,
          user_id: vm.user.userid,
          status: vm.input.ticketStatus.toLowerCase()
        }
        try {
          await ticket3TicketManagementApi.putTicketManagement({ data })
          vm.loading = false
          vm.$emit('updateTicketStatus', vm.input.ticketStatus)
          if (vm.input.ticketStatus.toLowerCase().includes('closed')) {
            // Close the chat
            vm.$store.dispatch('handleRemoveUserFromAdminTap', {
              user_id: vm.user.userid,
              pageid: vm.$store.state.livechat.pageid,
              type: 'admin'
            })
            vm.$store.dispatch('handleUpdateLivechatUser', {
              user_id: vm.user.userid,
              type: 'admin',
              data: {
                context: ''
              }
            })
          }
          vm.showManageTicketStatus = false
        } catch (error) {
          handleApiError(error)
        }
      } else {
        const data = {
          pageid: vm.$store.state.livechat.pageid,
          status: vm.input.ticketStatus.toLowerCase(),
          ticketId
        }
        api.ticket2UpdateTicket(data, () => {
          vm.loading = false
          vm.$emit('updateTicketStatus', vm.input.ticketStatus)
          vm.showManageTicketStatus = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item-ticket.vue